import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { NgbActiveModal } from '@cmps/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import { first } from 'rxjs/operators';

import {
    ColumnConfigItem,
    Icon,
    PersonOfInterest,
} from './model/fl-winning.global.model';
import { FLWinningPerson } from './model/fl-winning.model';
import { SortDirection } from './model/sort-direction.model';
import { FLWinningService } from './services/fl-winning.service';

@Component({
    selector: 'cmps-frontline-winning',
    templateUrl: './fl-winning.component.html',
})
export class FLWinningComponent implements OnInit {
    @Input() selectedUser: number;
    @Input() active: string[];
    @Input() OnFLPersonChange: Subject<FLWinningPerson>;
    @Output() metricsRendered: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() selectedUserChange: EventEmitter<PersonOfInterest> =
        new EventEmitter<PersonOfInterest>();

    @Input() flwinningData: FLWinningPerson;
    public columns: Observable<ColumnConfigItem[]>;
    public metriccolumns: Observable<ColumnConfigItem[]>;

    /** @private */ _tempFlWinningData: FLWinningPerson;

    public activetab = 'tab-performance';
    public activecolumns: Observable<number>;

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        private readonly _flWinningService: FLWinningService,
        public activeModal: NgbActiveModal,
    ) {}

    /** @private */
    appendSubordinates(
        subordinates?: FLWinningPerson[],
        parent?: FLWinningPerson,
    ): void {
        parent.subOrdinates = subordinates;
        if (subordinates == null) {
            parent.isExpanded = false;
        } else {
            parent.isExpanded = true;
        }

        this.assignParentBack(parent);
    }

    /** @private */
    assignParentBack(d: FLWinningPerson): void {
        if (this._tempFlWinningData.userId === d.userId) {
            this._tempFlWinningData = d;
        } else {
            searchAndReplace(this._tempFlWinningData, d);
        }
        function searchAndReplace(
            o: FLWinningPerson,
            p: FLWinningPerson,
        ): FLWinningPerson {
            if (o.userId === p.userId) {
                o = { ...p };
                return o;
            } else {
                if (o.subOrdinates?.length > 0) {
                    for (let x = 0; x < o.subOrdinates.length; x++) {
                        const y = searchAndReplace(o.subOrdinates[x], p);
                        if (y?.userId === o.subOrdinates[x].userId) {
                            o.subOrdinates[x] = y;
                        }
                    }
                }
            }
        }
        this._flWinningService.setCurrentFlWinningState(
            this._tempFlWinningData,
        );
    }

    getFlWinningData(level: number, data: any): void {
        const rowData = { ...data };

        if (level !== 1) {
            rowData.maxCommitmentsAssessed =
                this.flwinningData.commitmentsAssessed;
        }

        rowData.levelClass = `level${level}`;
        rowData.level = level;

        return rowData;
    }

    ngOnInit(): void {
        this._flWinningService.initializeColumnConfig();
        this.columns = this._flWinningService.flWinningColumns;
        this.columns.pipe(first()).subscribe();
        this.OnFLPersonChange.subscribe((res) => {
            this.flwinningData = { ...res };
            this._tempFlWinningData = { ...this.flwinningData };
        });
        this._tempFlWinningData = { ...this.flwinningData };
    }

    sortTeamByScore(force?: SortDirection): SortDirection {
        return this._flWinningService.sortTeamBy(
            'oascore',
            force,
            this._tempFlWinningData,
        );
    }

    sortTeamByExpected(force?: SortDirection): SortDirection {
        return this._flWinningService.sortTeamBy(
            'expected',
            force,
            this._tempFlWinningData,
        );
    }

    toggle(event, icon: Icon, columns: ColumnConfigItem[]): void {
        let newstate = null;

        if (icon.action != null) {
            newstate = this[icon.action](null, icon.actionParams);
        }

        if (icon?.state !== undefined) {
            columns.forEach((g) => {
                if (g.icon != null) {
                    g.icon.forEach((f) => {
                        if (
                            newstate === SortDirection.DEFAULT &&
                            f.defaultState != null
                        ) {
                            f.counter = f.defaultState;
                        } else {
                            f.counter = SortDirection.DEFAULT;
                        }
                    });
                }
            });
            icon.state = !icon.state;
            icon.counter = newstate;
        }
    }

    checkIfAllCollapsed(): void {
        const _flwinningData = this.flwinningData;

        if (
            _flwinningData.isExpanded === false &&
            _flwinningData.subOrdinates == null
        ) {
            this.sortTeamByExpected(SortDirection.DEFAULT);
            this.sortTeamByScore(SortDirection.ASC);

            const cols = this._flWinningService.getColumns();
            cols.forEach((g) => {
                if (g.icon != null) {
                    g.icon.forEach((f) => {
                        if (f.defaultState != null) {
                            f.counter = f.defaultState;
                        } else {
                            f.counter = SortDirection.DEFAULT;
                        }
                    });
                }
            });
        }
    }
}
